import { observer } from "mobx-react-lite";
import { FC } from "react";
import { useAppBannerLinkOnClickHandler } from "@/components/banners/app-callout-banner/utils/app-banner-link-handling";
import styled from "@emotion/styled";
import type { AppCalloutBannerEventParams } from "@/domains/metrics/tracked-event";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";

interface AppCalloutBannerInlineActionProps {
  label: string | null;
  url: string | null;
  trackingContext: AppCalloutBannerEventParams;
}

export const AppCalloutBannerInlineAction: FC<AppCalloutBannerInlineActionProps> = observer(
  ({ label, url, trackingContext }) => {
    const { onClickHandler } = useAppBannerLinkOnClickHandler({
      url: url || "",
      actionSlot: "inline",
      trackingContext,
    });

    if (!label) return null;
    if (!url) return null;

    return (
      <InlineActionText
        variant={MDSTextVariant.TextS}
        weight={MDSTextWeight.Regular}
        onClick={onClickHandler}
      >
        {label}
      </InlineActionText>
    );
  }
);

const InlineActionText = styled(MDSText)({
  display: "inline",
  marginLeft: "4px",
});
